import { Injectable } from '@angular/core';

@Injectable()
export class DefaultService {

	adunitPlayout: any;
	adunitDefaultTypes: any;

	constructor() {
		this.adunitPlayout = require('../resources/defaults/adunitPlayout.json');
		this.adunitDefaultTypes = require('../resources/defaults/playoutPositions.json');
	}

	getAdunitPlayoutDefault(adunitPositionType: string): any {
		let playout = {};
		let positionSuperType = '';

		if (adunitPositionType === 'inarticle') {
			positionSuperType = 'outstream';
		} else {
			positionSuperType = 'instream';
		}

		// First get the supertype (instream, outstream or display) settings
		playout = {...this.adunitPlayout, ...this.adunitDefaultTypes[positionSuperType]};

		if (this.adunitDefaultTypes[adunitPositionType]) {
			playout = {...playout, ...this.adunitDefaultTypes[adunitPositionType]};
		}

		return playout;
	}
}
